import React, { createContext } from "react";

import { AssetListingConfig } from "../../common/config/AssetListingConfig";
import { AncillaryCatalogueEntry } from "./AncillaryCatalogueEntry";

interface ISingleAncillaryContext {
    ancillaryId: string;
    ancillary: AncillaryCatalogueEntry;
    isLoading: boolean;
    listingConfig: AssetListingConfig;
    saveListingConfig: (config: AssetListingConfig) => void;
}

const defaultSingleAncillaryContext: ISingleAncillaryContext = {} as ISingleAncillaryContext;

export const SingleAncillaryContext = createContext<ISingleAncillaryContext>(defaultSingleAncillaryContext);
